export default __webpack_public_path__ + "static/media/BOHATER.e0fa7b3f.png";